import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type WindowSillInfoData = {
  measurementUuid: string;
  roomName: string;
  material: 'PCV' | 'MDF' | 'conglomerate' | 'granite' | 'overlay' | 'steel' | 'aluminum';
  thickness: string;
  corners: 'straightAngle' | 'rounded';
  color: string;
  windowSill: Array<{
    width: string;
    length: string;
    amount: string;
    connectingWithAnother: boolean;
    comments?: string;
  }>;
  comments?: string;
};

const usePutWindowSillsInfo = (
  options?: UseMutationOptions<any, Error, WindowSillInfoData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['editWindowSillsInfo'],
    mutationFn: async (data) => {
      return axiosInstance
        .put('/measurement/window-sills/info', data)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie danych parapetów...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'edit-window-sills-info',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Dane parapetów zaktualizowane pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'edit-window-sills-info',
      });
      queryClient.invalidateQueries({ queryKey: ['windowSillsInfo'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji danych parapetów.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'edit-window-sills-info',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default usePutWindowSillsInfo;
